module.exports = __webpack_public_path__ + "static/media/unitedKingdom.b1faf7ec.png";